/**
 * @see https://babeljs.io/docs/usage/polyfill/
 * Для Symbol в IE (хотя это подключение не только Symbol обеспечивает, видимо, но иного рабочего способа не определил)
 */
require('babel-polyfill');

// main.js
//var Vue = require('vue/dist/vue.js');
import '../../css/skin-blue.css'
import '../../css/libs/owl.carousel.css'
import '../../css/libs/font-awesome/css/font-awesome.css'
import '../../css/digitec-style-skin.css'
import '../../css/helpers.css'
import '../../css/vcenter.css'
import '../../css/colors.css';
import '../../css/productpage.css';
import '../../css/libs/owl.carousel.css'
import '../../css/libs/magnific-popup.css'
import '../../css/libs/liquid-slider.css'

import '../../css/elements/video.scss';

import '../../css/digitec-style.scss'
import '../../css/common.scss'
import '../styles/app.scss'

import '../semantic/dist/semantic.css'

window._ = require('lodash');

import Vue from 'vue';

//Vue.component('upload', require('./components/Upload.vue'));

//Vue.use(require('vue-scroll'));

Vue.component('scrolltop', require('./components/scrolltop/scrolltop.vue'));

Vue.component('images', require('./components/images/lightbox.vue'));

Vue.component('masked-input', require('./components/maskedinput/maskedinput.vue'));

Vue.component('autocomplete', require('./components/autocomplete/autocomplete.vue'));
//require('vue2-autocomplete-js/dist/style/vue2-autocomplete.css');

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-default/index.css'
Vue.use(ElementUI);
import querystring from 'querystring'

import VueSimpleBreakpoints from 'vue-simple-breakpoints'

Vue.use(VueSimpleBreakpoints, { mobile: 767 })

//import vScroll from 'vue-scroll'
//Vue.use(vScroll)

Vue.component('portfolio', require('./components/portfolio/portfolio.vue'));
Vue.component('productcomments', require('./components/productcomments/productcomments.vue'));
Vue.component('scrollfire', require('./components/scrollfire/scrollfire.vue'));

window.vm = new Vue({
    el: '#prime',
    data: {
        isShowComments: false,
        modalclose: true,
        keyinput: true,
        mousescroll: true,
        showplaybutton: true,
        showfullbutton: true,
        showclosebutton: true,
        showcaption: true,
        imagecountseparator: 'из',
        showimagecount: true,
        showthumbnails: true,
        isMobile: false,
        isMobileAndTablet: false
    },
    mixins: [
        require("vue-mixins/onWindowScroll"),
        require("vue-mixins/onWindowResize")
    ],
    methods: {
        showComments: function() {
            console.log('showCOmments');
            this.isShowComments = true;
        },
        mobileBreakpoints: function() {
            this.isMobile = this.$breakpoints.isMobile();
            this.isMobileAndTablet = this.$breakpoints.isMobile() || this.$breakpoints.isTablet();
        }
    },
    mounted() {
        this.mobileBreakpoints();
        this.onWindowResize(() => {
            this.mobileBreakpoints();
        })
    }
});

require('../javascript/app');

//require('../javascript/sliders');



// WEBPACK FOOTER //
// ./assets/vue/main.js